import { Layout } from 'antd';
import React from 'react';
import { Outlet } from 'react-router-dom';
interface SectionLayoutProps {}

export const SectionLayout: React.FC<SectionLayoutProps> = (_props) => {

  return (
    <Layout>
      <Layout.Content
        style={
          {
            minHeight: '100%',
            background: 'white',
            marginTop: '64px'
          } as React.CSSProperties
        }
      >
        <Outlet />
      </Layout.Content>
    </Layout>
  );
};
